import { Box, Flex } from '@chakra-ui/react';

import { ArrowUp, ChevronDown, MeshMavenGreen } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import BetaTag from 'uiToolkitV1/Tag/BetaTag';

const SuggestionsTemplate = ({ setShowList, showList, children, title, subTitle }) => {
  const mobileViewButtonProps = isMobileView() ? { marginLeft: '0 ', width: 'fit-content ' } : {};
  return (
    <Box
      sx={{
        borderRadius: '8px',
        padding: '1px',
        background:
          'linear-gradient(90deg, rgba(0, 142, 240, 0.50) 1.83%, rgba(236, 59, 100, 0.50) 34.86%, rgba(255, 194, 0, 0.50) 65.54%, rgba(92, 196, 97, 0.50) 100%)',
      }}
    >
      <Box background="white" borderRadius="8px">
        <Flex
          sx={{
            height: isMobileView() ? '90px' : '76px',
            background:
              'linear-gradient(106.11deg, rgba(0, 142, 240, 0.03) 1.41%, rgba(236, 59, 100, 0.03) 36.8%, rgba(255, 194, 0, 0.03) 69.67%, rgba(92, 196, 97, 0.03) 106.6%)',
          }}
          display="flex"
          alignItems="center"
          pl={isMobileView() ? '12px' : '16px'}
          pr={isMobileView() ? '0px' : '24px'}
          borderBottom="1px solid #CFD7DF"
        >
          <Flex flexDirection={isMobileView() ? 'column' : 'row'} w="100%">
            <ListItemComp
              title={
                <Flex alignItems="center" fontSize={isMobileView() ? '12px' : '14px'}>
                  <span style={{ 'text-wrap': 'auto' }}>{title}</span>
                  <BetaTag ml={2} />
                </Flex>
              }
              subTitle={subTitle}
              withoutBackground
              // eslint-disable-next-line react/no-unstable-nested-components
              LeftComponent={() => (
                <Flex h="100%" w="100%" justifyContent="center" alignItems="center">
                  <MeshMavenGreen boxSize="48px" />
                </Flex>
              )}
            />

            <Button
              sx={{
                marginLeft: 'auto',
                ...mobileViewButtonProps,
              }}
              onClick={() => setShowList(!showList)}
              variant="tertiary"
              EndIcon={showList ? ArrowUp : ChevronDown}
            >
              {showList ? 'Hide Suggestions' : 'Show Suggestions'}
            </Button>
          </Flex>
        </Flex>
        {showList && children}
      </Box>
    </Box>
  );
};

export default SuggestionsTemplate;
